import { render, staticRenderFns } from "./ShiptecnicoForm.vue?vue&type=template&id=52bec6ab"
import script from "./ShiptecnicoForm.vue?vue&type=script&lang=js"
export * from "./ShiptecnicoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports